import { useState,useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { CropperRef, Cropper } from 'react-advanced-cropper';
import Form from 'react-bootstrap/Form';
import getCroppedImg from "./cropImage"
import "react-advanced-cropper/dist/style.css";


const EditProfileImage = ({setShow,show,uri,setImageUri,aspect_ratio=3/4}) => {
  

    const handleClose =async  () => {
      const croppedImage = await getCroppedImg(
        uri,
        {width:croppedAreaPixels?.width,height:croppedAreaPixels?.height,y:croppedAreaPixels?.top,x:croppedAreaPixels?.left},
        rotation
      )
      setImageUri(croppedImage)
      
      setShow(false);
    }
   
    const handleShow = () => setShow(true);
    const cropperRef=useRef()
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [rotation, setRotation] = useState(0)
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [croppedImage, setCroppedImage] = useState(null)
  
    // const onCropComplete = (croppedArea, croppedAreaPixels) => {
    //   setCroppedAreaPixels(croppedAreaPixels)
    // }
  
    const showCroppedImage = async () => {
      try {
       
        const croppedImage = await getCroppedImg(
          uri,
          {width:croppedAreaPixels?.width,height:croppedAreaPixels?.height,y:croppedAreaPixels?.top,x:croppedAreaPixels?.left},
          rotation
        )
        setImageUri(croppedImage)
        handleClose()

      } catch (e) {
        console.error(e)
      }
    }
  

    const onChange = (cropper) => {
      setCroppedAreaPixels(cropper.getCoordinates());
  };
  
  
    return (
      <>
      <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
     <div className={"edit_profile_div"}>
        {/* <Cropper
          image={uri}
          crop={crop}
          rotation={rotation}
          zoom={zoom}
          aspect={4/3}
          onCropChange={setCrop}
          onRotationChange={setRotation}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        /> */}
            <Cropper
              className="position-relative cropper"
              ref={cropperRef}
              src={uri}
              autoZoom={true}
              resizeImage={true}  // Ensure this is correctly named (it may need to be resizeImage instead of resizeImag)ag)
              moveImage={true}
              onChange={onChange}
              zoomTo={0.5}
              // aspectRatio={3 / 4}  // 3:4 aspect ratio (portrait mode)
              aspectRatio={aspect_ratio}
              minCropBoxHeight={40} // Minimum crop box height: 40px
              minCropBoxWidth={30}  // Minimum crop box width: 30px
              viewMode={1}
              background={false}
              responsive={true}
              autoCropArea={1}
              checkOrientation={false}
              guides={true}
            />

       </div>
     </Modal.Body>
          <Modal.Footer>
            {/* <Form.Range 
                  value={zoom}
                  min={1}
                  max={10}
                  step={0.1}
                  aria-labelledby="Zoom"
                
                  onChange={(e) =>{
                   setZoom(e.target.value)

                  }}  
            /> */}
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={showCroppedImage}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
}

export default EditProfileImage